import { useState,useRef ,useEffect} from "react";
import "./searchBar.scss";
import {useNavigate } from "react-router-dom";
// import ComponentTagSelector from "../tags/ComponentTagSelector";
// import { useColonies } from "../../context/ColoniesContext";


import Comp_Colonies from "../datacontrols/controlColony";
import search from "../../assets/search.png";


const types = [1, 2];

function SearchBar() {
  const navigate=useNavigate();

  const [colonies,SetColonies]=useState([]);

  // const colonies=useColonies();

  // console.log("Colonies:", colonies);

  const tagrefColony=useRef(null);
  // useEffect(() => {
  //   // if (tagrefColony.current) {
  //     // You can now safely access tagrefColony.current.getTags()
      
  //     const link = buildLink();
  //     console.log('ComponentTagSelector is mounted');
  //   // }
  // }, []);


  const [query, setQuery] = useState({
    transtype: 1,
    // colonies: [],
    minprice: 0,
    maxprice: 0,
  });

  const switchType = (val) => {
    setQuery((prev) => ({ ...prev,transtype: val }));
  };

  const handleChange = (e) => {
    setQuery((prev) => {
      const curquery = { ...prev, [e.target.name]: e.target.value };
      // console.log(curquery);
      return curquery;
    });
  };

  const buildLink = () => {
    // if (!tagrefColony.current) {
    //   // Handle the case where the ref is not yet assigned
    //   return;
    // }
  


    const params = new URLSearchParams();
    params.append("transtype", query.transtype);
    // if (query.city) params.append("city", query.city);
    if (query.minprice > 0) params.append("minprice", query.minprice);
    if (query.maxprice > 0) params.append("maxprice", query.maxprice);

    // if (tagrefColony.current) {
    //   alert(tagrefColony.current.getTags());
    // }



    const colonytags= tagrefColony.current?tagrefColony.current.getColonyTags().map((tag)=>tag.id):[];
    // console.log('colony tags',colonytags); 

    

    // Serialize the colonies array as a JSON string
    if (Array.isArray(colonytags) && colonytags.length > 0) {
      params.append("colonies", JSON.stringify(colonytags));
    }
    return params
//    return `/list?${params.toString()}`;
  };



const buildQueryObject = () => {
  return {
    transtype: query.transtype,
    minprice: query.minprice,
    maxprice: query.maxprice,
    colonies: tagrefColony.current?tagrefColony.current.getColonyTags().filter((tag) => tag.status !== "delete").map((tag)=>tag.id):[],
  };
};




  //  console.log("Current transtype:", query.transtype);
  const handleSearchButtonClick = ( e) => {
    e.preventDefault()
    // const params = buildLink();
    const queryobject = buildQueryObject();

    // navigate(`/list`);
    // Use the generated link as needed

    navigate("/list", {
      state:{
        ...queryobject,
        fromMenu:true,
      }
    });



  };

  // const handleLinkClick = (e) => {
  //   e.preventDefault();
  //   // Perform your additional logic here
  //   // For example, validate form data or set state
  //   // If conditions are met, programmatically navigate to the desired route
  // };


  return (
    <div className="searchBarContainer">
      <div className="type">
        {types.map((type) => (
          <button
            key={type}
            onClick={() => switchType(type)}
            className={query.transtype === type ? "active" : ""}
          >
            {type==1?"Buy":"Rent"}
          </button>
        ))}
      </div>
      <div className="searchRow">

        <form>
          <div name="tagcolony" className="tagColony">
            <Comp_Colonies
              ref={tagrefColony}
              // style={{ width: "100%" }}
              selectedTags={colonies}
              // setSelectedTags={(tags) =>
              //   SetColonies(tags)
              // }

              setSelectedTags={SetColonies}

            >
              
            </Comp_Colonies>
          </div>
          <div className="priceRange">
            <div className="priceRangeInputs">

                <input
                  type="number"
                  name="minprice"
                  min={0}
                  max={10000000}
                  placeholder="Min Price"
                  onChange={handleChange}
                />
                <input
                  type="number"
                  name="maxprice"
                  min={0}
                  max={10000000}
                  placeholder="Max Price"
                  onChange={handleChange}
                />
            </div>

              <button className="searchButton" onClick={handleSearchButtonClick}>
                <img src={search} alt="" />
              </button>
              

          </div>



        </form>

      </div>

    </div>
  );
}

export default SearchBar;
